import { GeocoderResponseArray } from 'embed/constants'
import { googleMapsApiToken } from 'embed/constants/config'
import { buildUrl } from 'embed/utils'
import { ApiPromise } from '../Api'
import { fetch } from 'whatwg-fetch'

export class Geocoder {
  public get(params?: object): ApiPromise<GeocoderResponseArray> {
    const url = buildUrl('https://maps.googleapis.com/maps/api/geocode/json', {
      key: googleMapsApiToken,
      ...params,
    })
    return fetch(url.href, { method: 'GET' }).then(async (res) => ({
      ...res,
      data: await res.json(),
      headers: res.headers,
      status: res.status,
      statusText: res.statusText,
    }))
  }
}

export default new Geocoder()
